import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { AnalyticsData } from "@shared/types/analytics";

export const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export function useAnalytics() {
  return useQuery({
    queryKey: ["wallboard", "analytics"],
    queryFn: () => apiGet<AnalyticsData>("/api/wallboard/analytics"),
    refetchInterval: REFRESH_INTERVAL_MS,
  });
}
